import { LightningElement } from "lwc";

export default class ActivityTimeline extends LightningElement {
  static renderMode = `light`;
}
